import PropsTypes from 'prop-types';
import React from 'react';

export default class HallSelection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            display: this.props.maps != null ? 'block' : 'none',
            top: 0,
            left: 0,
        }
    }
    
    show() {
        this.setState({display: 'block'});
    }
    
    hide() {
        this.setState({display: 'none'});
        this.props.onSelection();
        //this.props.maps.forEach((map) => {console.log(map.NAME);});
    }

    componentDidUpdate(prevProps) {
        var newDisplay = this.props.maps != null ? 'block' : 'none';
        if (newDisplay !== this.state.display) {
            this.setState({display: newDisplay});
        }
    }
    
    render() {
        const { t } = this.props;
        
        return (
          <div id="hallSelection" className="modal" style={{ display: this.state.display, top: this.props.top, left: this.props.left }}>
            <div className="modal-content">
              <div className="close_div">
                <span className="close" onClick={() => {this.hide()}}>
                  &times;
                </span>
              </div>

                <p>{t('selectHallLayer')}</p>
              <div className="content">
                {this.props.maps != null ? this.props.maps.map((map) => {return (<button className="hallSelectionButton" key={map.ID} onClick={() => { this.props.onSelection(map) }}> { map.NAME } </button> )}) : <p>Nothing</p>}
              </div>
            </div>
          </div>
        );
    }
}

HallSelection.propTypes = {
  display: PropsTypes.oneOf(['none', 'block']),
  onSelection: PropsTypes.func.isRequired,
};

